/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

const constants = require('./constants');

/**
 * @module enervee_utils.ads
 */
function googleAdDirective() {
    return {
        restrict: 'E',
        scope: {
            tagname: '<',
            showTagEvent: '<?',
            categoryCode: '<?',
            adLoaded: '=?', // really a one-way (up-only)
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: googleAdController,
        template: require('./googleAdView.html'),
    };
}

googleAdController.$inject = [
    '$scope',
    '$timeout',
    '$window',
    'GoogleAdService',
    'UtilService',
];
function googleAdController(
    $scope,
    $timeout,
    $window,
    GoogleAdService,
    UtilService
) {
    const vm = this;
    let _showTagHandler = null;
    let _loadAdCalled = false;
    let _badAdConfig = false;
    vm.isEnabled = GoogleAdService.isEnabled;
    this.$onInit = () => {
        loadIfViewportMatches();
        angular.element($window).bind('resize', loadIfViewportMatches);
    }

    /**
     * Grab the config for the ad and load it!
     * If the ad has already loaded, don't do anything.
     * If there's no config for the tagname, don't do anything.
     */
    function loadAd() {
        if (_loadAdCalled) return;
        const config = GoogleAdService.getConfigForAdSlot(vm.tagname);
        if (!config) {
            _badAdConfig = true;
            return;
        }
        GoogleAdService.defineAdSlot(
            config.adUnitPath,
            config.sizes,
            vm.tagname,
            vm.categoryCode,
        );
        GoogleAdService.onAdSlotRendered(vm.tagname, () => {
            vm._adLoaded = true;
            $timeout(() => {
                vm.adLoaded = true;
            }, 50);
        });
        _loadAdCalled = true;
    }

    /**
     * Checks that the viewport size (mobile vs. desktop) matches
     * the size the ad is named for (MOB- vs. DSK-).
     * @returns {Boolean}
     */
    function viewportIsRightSize() {
        const displayIsMobile = UtilService.isMobile();
        const adIsMobile = vm.tagname.startsWith(constants.MOBILE_PREFIX);
        return displayIsMobile === adIsMobile;
    }

    /**
     * Set up a one-time handler for when this scope receives an event
     * matching the name of showTagEvent.
     */
    function setShowTagHandler() {
        _showTagHandler = $scope.$on(vm.showTagEvent, () => {
            loadAd();
            clearShowTagHandler();
        });
    }

    /**
     * If there is a showTagEvent name set, and there isn't a handler
     * already, set it up. If there's no showTagEvent name set, just
     * load the ad right away.
     */
    function setShowTagOrLoad() {
        if (vm.showTagEvent && !showTagHandler) {
            setShowTagHandler();
        } else if (!vm.showTagEvent) {
            loadAd();
        }
    }

    /**
     * Clears the listener for the showTagEvent
     */
    function clearShowTagHandler() {
        _showTagHandler();
        _showTagHandler = null;
    }

    /**
     * If the viewport matches the ad size, then set the showTagEvent
     * handler or just load the ad.
     * If the viewport doesn't match and  there's a showTagEvent handler
     * already set, clear it.
     * If the ad has already loaded or if the config for the ad is bad,
     * abort before doing anything.
     */
    function loadIfViewportMatches() {
        if (_loadAdCalled || _badAdConfig) return;
        const adMatchesViewport = viewportIsRightSize();
        if (!adMatchesViewport && _showTagHandler) {
            clearShowTagHandler();
            return;
        } else if (adMatchesViewport) {
            setShowTagOrLoad();
        }
    }
}

module.exports = googleAdDirective;
